/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMinRightIcon16Regular = forwardRef('ArrowDim2DiagMinRightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M14.28 2.78a.75.75 0 0 0-1.06-1.06L9.75 5.19V2.5a.75.75 0 0 0-1.5 0v4c0 .69.56 1.25 1.25 1.25h4a.75.75 0 0 0 0-1.5h-2.69l3.47-3.47Z" }),
        React.createElement("path", { d: "M6.25 13.5v-2.69l-3.47 3.47a.75.75 0 0 1-1.06-1.06l3.47-3.47H2.5a.75.75 0 0 1 0-1.5h4c.69 0 1.25.56 1.25 1.25v4a.75.75 0 0 1-1.5 0Z" })));
});
